import { Dialog, DialogActions, Typography } from "@mui/material";

const SequenceOverlapModal = ({
  showSequenceOverlapModal,
  setShowSequenceOverlapModal,
}) => {
  return (
    <Dialog
      open={showSequenceOverlapModal}
      onClose={() => setShowSequenceOverlapModal(false)}
    >
      <div
        style={{
          width: "400px",
          padding: "20px",
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Overlapping Ranges
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          The selected ranges overlap with existing ones. Please adjust them.
        </Typography>
      </div>
      <DialogActions>
        <button
          className="create-btn-outlined"
          style={{ width: "120px" }}
          onClick={() => {
            setShowSequenceOverlapModal(false);
          }}
        >
          Close
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default SequenceOverlapModal;
